import React from 'react';
import merge from 'lodash/merge';

export const mergeOverrides = <T,>(defaults: T, overrides?: T) =>
  overrides ? merge({}, defaults, overrides) : defaults;

export const linkFigma = (figmaUrl: string) => ({
  design: { type: 'figma', url: figmaUrl },
});

export const reflow = (node: HTMLElement) => node.scrollTop;

type RenderNodeOrComponentParams<T extends object> =
  | {
      Component: React.ComponentType<React.PropsWithChildren<T>>;
      node: undefined;
      props: T;
    }
  | {
      Component: undefined;
      node: React.ReactNode;
      props: undefined;
    }
  | {
      Component?: React.ComponentType<React.PropsWithChildren<T>>;
      node?: React.ReactNode;
      props?: T;
    };

export const renderNodeOrComponent = <T extends object>(params: RenderNodeOrComponentParams<T>) => {
  const { Component, node, props = {} } = params;
  if (node) {
    return node;
  }
  if (Component) {
    return <Component {...(props as T)} />;
  }
  return null;
};

export const getDomAttributes = (props: Record<string, any>) => {
  const domAttributes: Record<string, any> = {};

  for (const key in props) {
    if (
      key.startsWith('data-') ||
      key.startsWith('aria-') ||
      key === 'id' ||
      key === 'title' ||
      key === 'role'
    ) {
      domAttributes[key] = props[key];
    }
  }

  return domAttributes;
};
